export default __webpack_public_path__ + "static/media/marker-gray-orange-yellow.e28751a8.png";